import React, {Component} from 'react'
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap"
import StatisticsByDays from "./StatisticsByDays"
import StatisticsByTypes from "./StatisticsByTypes"


class PackingStatistics extends Component {
    render() {
        return (
            <div className="PackingStatistics">
                <Card>
                    <CardHeader className="bg-warning text-white header-elements-inline">
                        <h2 className="card-title"><i className="icon-box-add"/> Thống kê đóng hàng</h2>
                    </CardHeader>

                    <CardBody>
                        <Row>
                            <Col md={6} className='has-border'>
                                <StatisticsByTypes/>
                            </Col>

                            <Col md={6}>
                                <StatisticsByDays/>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default PackingStatistics
